import {
  Button as DSButton,
  ButtonProps as DSButtonProps,
  cn,
  Loader2Icon,
} from 'oddle-shop-monorepo.design-system'
import { useSelector } from 'react-redux'
import { selectThemeSettingData } from '@/redux/customisation'

interface ButtonProps extends DSButtonProps {
  isLoading?: boolean
  secondary?: boolean
}

const Button = ({
  children,
  isLoading,
  className,
  variant,
  size,
  secondary,
  ...props
}: ButtonProps) => {
  const themeSettings = useSelector(selectThemeSettingData)

  return (
    <DSButton
      {...props}
      disabled={isLoading || props.disabled}
      className={cn(
        'rounded-lg border-none text-base leading-[20px] transition-all duration-500 ease-out hover:opacity-90 focus-visible:ring-0 focus-visible:ring-offset-0 md:text-lg md:leading-[20px] lg:text-lg lg:leading-[20px]',
        themeSettings?.settings?.buttonStyle === 'outline' ||
          variant === 'outline' ||
          secondary
          ? 'text-button border-button border-2 border-solid bg-transparent shadow-sm'
          : '',
        !variant &&
          themeSettings?.settings?.buttonStyle === 'solid' &&
          !secondary
          ? 'text-button-text bg-button shadow-sm'
          : '',
        !variant &&
          themeSettings?.settings?.buttonStyle === 'raised' &&
          !secondary
          ? 'text-button-text bg-button shadow-[var(--button-color-darker)_0px_4px_0px]'
          : '',
        themeSettings?.settings?.buttonShape === 'round' ? 'rounded-lg' : '',
        themeSettings?.settings?.buttonShape === 'square' ? 'rounded-none' : '',
        themeSettings?.settings?.buttonShape === 'pill' ? 'rounded-full' : '',
        variant === 'link'
          ? 'border-none bg-transparent no-underline shadow-none hover:underline'
          : '',
        variant === 'ghost' ? 'border-none bg-transparent shadow-none' : '',
        className
      )}
    >
      {isLoading ? <Loader2Icon className="h-4 w-4 animate-spin" /> : children}
    </DSButton>
  )
}

export default Button
